// extracted by mini-css-extract-plugin
export var collapsed = "ContentNodeCard-module--collapsed--d7sKX";
export var excerpt = "ContentNodeCard-module--excerpt--r2zw3";